var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header',{attrs:{"iddiario":_vm.iddiario}}),_c('app-section-intro'),_c('app-section-card-description'),_c('app-section-medal-table-calendar'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }